// Scoped to the AI route. Preserve vertical scrolling, zoom and device-control dragging.
export function installAiGestureGuard(root) {
  const html=document.documentElement,previous=html.style.overscrollBehaviorX
  html.style.overscrollBehaviorX='none'
  let start=null
  const begin=e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null}
  const move=e=>{
    if(!start||e.touches.length!==1)return
    if(e.target.closest && e.target.closest('input,textarea,[role="slider"]'))return
    const dx=e.touches[0].clientX-start.x,dy=e.touches[0].clientY-start.y
    if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){if(e.cancelable)e.preventDefault();e.stopPropagation()}
  }
  const end=()=>{start=null}
  const wheel=e=>{if(Math.abs(e.deltaX)>Math.abs(e.deltaY)&&!e.ctrlKey){if(e.cancelable)e.preventDefault();e.stopPropagation()}}
  root.addEventListener('touchstart',begin,{passive:true})
  root.addEventListener('touchmove',move,{passive:false})
  root.addEventListener('touchend',end)
  root.addEventListener('touchcancel',end)
  root.addEventListener('wheel',wheel,{passive:false})
  return ()=>{root.removeEventListener('touchstart',begin);root.removeEventListener('touchmove',move);root.removeEventListener('touchend',end);root.removeEventListener('touchcancel',end);root.removeEventListener('wheel',wheel);if(html.style.overscrollBehaviorX==='none')html.style.overscrollBehaviorX=previous}
}
